class WhatsHelp {
  constructor(config) {
    const options = {
      facebook: config.version,
      company_logo_url: config.company_logo_url || '',
      greeting_message: config.greeting_message && 'Hello, how may we help you?',
      call_to_action: config.call_to_action || 'Chat',
      position: config.position || 'right',
    };
    const proto = document.location.protocol, host = 'whatshelp.io', url = proto + '//static.' + host;
    const s = document.createElement('script'); s.type = 'text/javascript'; s.async = true; s.src = url + '/widget-send-button/js/init.js';
    s.onload = function () { WhWidgetSendButton.init(host, proto, options); };
    const x = document.getElementsByTagName('script')[0]; x.parentNode.insertBefore(s, x);
  }
}

export default WhatsHelp;



// WEBPACK FOOTER //
// ./src/services/whatshelp.js